import { createFileRoute } from '@tanstack/react-router';
import { useMemo, useState } from 'react';
import { useSetCommiteeUserArchived } from '@/api/commitee/commitee.mutations';
import { type CommiteeUser, useCommiteeUsersWithGuard } from '@/api/commitee/commitee.queries';
import { Title } from '@/components/Title';
import { Table } from '@/components/table/Table';
import { useTableState } from '@/components/table/useTableState';
import { getUsersColumns } from './columns/users-columns';
import { EditUserDialog } from './components/EditUserDialog';

export const Route = createFileRoute('/gestion/entreprise/$id/users')({
  component: UsersTab,
});

function UsersTab() {
  const { id } = Route.useParams();
  const commiteeId = Number(id);
  const { data: users, isLoading, isError } = useCommiteeUsersWithGuard();
  const { mutate: setArchived } = useSetCommiteeUserArchived(commiteeId);
  const [userToEdit, setUserToEdit] = useState<CommiteeUser | null>(null);

  const columns = useMemo(
    () =>
      getUsersColumns({
        onEdit: setUserToEdit,
        onSetArchived: async (user, archived) => {
          await setArchived({ userId: user.id, archived });
        },
      }),
    [setArchived]
  );
  const tableState = useTableState('commitee-users', { columns });

  return (
    <div className="flex flex-col gap-4">
      <Title>Utilisateurs{users ? ` (${users.length})` : ''}</Title>
      <Table
        entity={{ singular: 'utilisateur' }}
        data={users}
        columns={columns}
        tableState={tableState}
        disableHover
        isLoading={isLoading}
        isError={isError}
      />
      {userToEdit && (
        <EditUserDialog
          key={userToEdit.id}
          commiteeId={commiteeId}
          user={userToEdit}
          open
          onOpenChange={(open) => !open && setUserToEdit(null)}
        />
      )}
    </div>
  );
}
